var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',{class:_vm.grayBg ? 'bg-gray' : ''},[(_vm.activity)?_c('v-col',[_c('v-row',[_c('span',{staticClass:"grey--text"},[_vm._v(_vm._s(_vm.activity.updated_at))])]),_c('v-row',[_c('v-container',[_c('h2',[_vm._v(_vm._s(_vm.fetchActivityI18n))])])],1)],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }